import type { TranslationInterface } from '.';

export const NorwegianLanguage: TranslationInterface = {
  write_a_message_placeholder: 'Skriv en melding...',
  your_issue_has_been_resolved: 'Problemet ditt er løst!',
  new_conversation: 'Ny samtale',
  welcome_screen_title: 'Velkommen til vår kundestøtte-chat',
  welcome_screen_description:
    'Vi er her for å hjelpe! Start en samtale så kommer vi tilbake til deg så snart som mulig.',
  your_name_placeholder: 'Ditt navn',
  your_email_placeholder: 'Din e-postadresse',
  start_chat_button: 'Snakk med kundestøtte',
  start_chat_button_loading: 'Kobler til...',
  i_need_more_help: 'Jeg trenger mer hjelp',
  this_was_helpful: 'Dette var nyttig',
  optional: 'Valgfritt',
  no_conversations_yet: 'Ingen samtaler ennå',
  back_to_conversations: 'Tilbake til samtaler',
  closed_conversations: 'Lukkede samtaler',
  csat_title: 'Hvordan var samtalen din?',
  csat_submitted_title: 'Du vurderte samtalen som',
  csat_feedback_placeholder: 'Fortell oss mer... (valgfritt)',
  follow_up_placeholder: 'Følg opp…',
  companion_layout_label: 'Oppsett',
  companion_layout_floating: 'Flytende',
  companion_layout_sidebar: 'Sidepanel',
  companion_layout_fullscreen: 'Fullskjerm',
  companion_close: 'Lukk',
  companion_history: 'Samtalehistorikk',
  companion_expand_chat: 'Utvid chatten',
  companion_sidebar_dock_label: 'Dokking',
  companion_sidebar_side_label: 'Side',
  companion_sidebar_left: 'Venstre',
  companion_sidebar_right: 'Høyre',
  companion_resize_chat: 'Endre størrelsen på chatten',
  scroll_to_bottom: 'Rull til bunnen',
  thinking: 'Tenker…',
  running: 'Kjører…',
  steps: 'trinn',
  step_arguments: 'Argumenter',
  step_result: 'Resultat',
  attach_files:
    'Legg ved bilder, videoer, PDF-er eller regneark (maksimal størrelse 25 MB)',
  mark_page_active:
    'Klikk på noe på siden for å markere det — Esc for å avbryte',
  mark_page: 'Marker noe på siden for å spørre om det',
  stop_response: 'Stopp svar',
  copy_reply: 'Kopier svar',
  mentions_empty: 'Ingen treff',
  copied: 'Kopiert',
  send_message: 'Send melding',
  upload_failed: 'Opplasting mislyktes: {error}',
  remove_attachment: 'Fjern vedlegg',
  json_no_items: 'Ingen elementer',
  json_no_data: 'Ingen data',
  json_no_chart_data: 'Ingen data for diagrammet',
  json_unsupported: 'Ikke støttet: {type}',
  json_see_less: 'Vis mindre',
  json_phone_agent: 'Telefonagent',
  json_phone_agent_test: 'Test via nett',
  page_context_remove: 'Fjern sidekontekst',
  json_see_more: 'Vis {count} til',
  queued_label: '{count} I kø',
  remove_queued_message: 'Fjern meldingen fra køen',
  send_queued_now: 'Send meldinger i køen nå',
  turn_failed_message: 'Noe gikk galt, og svaret kom ikke fram.',
  turn_failed_retry: 'Prøv igjen',
  page_mark_hint: 'Klikk på noe for å markere det',
  page_mark_escape: 'Esc',
  page_mark_shape_box: 'Ramme',
  page_mark_shape_circle: 'Sirkel',
  page_mark_shape_arrow: 'Pil',
  page_mark_shape_bracket: 'Klamme',
  page_mark_shape_underline: 'Understreking',
  page_mark_shape_highlight: 'Utheving',
  page_mark_shape_strike_through: 'Gjennomstreking',
  page_mark_shape_crossed_off: 'Kryss ut',
  page_mark_shape_aria: 'Markeringsform: {shape}',
  page_mark_note_placeholder: 'Legg til et notat… (Enter for å legge ved)',
  page_mark_attach: 'Legg ved markering',
  page_mark_remove: 'Fjern {label}',
  page_mark_region: 'Markert område',
  page_mark_default_message: 'Hva er dette?',
  file_rejected: 'Filtypen støttes ikke, eller filen er for stor.',
  dictate: 'Dikter',
  stop_dictation: 'Stopp diktering',
  dictation_mic_blocked: 'Tillat mikrofontilgang for å diktere',
  dictation_unavailable: 'Diktering er ikke tilgjengelig akkurat nå',
  questions_back: 'Tilbake',
  questions_next: 'Neste',
  questions_send: 'Send',
  questions_type_answer: 'Jeg skriver det selv',
  questions_answer_placeholder: 'Skriv svaret ditt…',
  close_conversation_title: 'Lukk samtale',
  close_conversation_description:
    'Er du sikker på at du vil lukke denne samtalen?',
  close_conversation_cancel: 'Nei',
  close_conversation_confirm: 'Ja',
  dialog_close: 'Lukk',
  zoom_in: 'Zoom inn',
  zoom_out: 'Zoom ut',
  reset_zoom: 'Tilbakestill zoom',
  support_chat_aria_label: 'Support-chat',
};
